import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiIconComponent } from '@siemens/element-ng/icon';
import type { ILocation } from '../../../../../shared/interfaces/ILocation';

@Component({
    selector: 'app-tab-communication',
    templateUrl: './tab-communication.component.html',
    styleUrls: ['./tab-communication.component.scss'],
    imports: [TranslatePipe, SiIconComponent]
})
export class TabCommunicationComponent {
    public readonly location = input.required<ILocation>();
}
